import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47d4618e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jumbotron p-1 text-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("h5", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chart-bar" }),
    /*#__PURE__*/_createTextVNode(" Store Reports")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "font-weight-bold" }, "Get the complete reporting of store.")
], -1))
const _hoisted_3 = { class: "section-menu" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "menu-link-settings" }
const _hoisted_8 = { class: "menu-link-detail-settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportList, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
              (_ctx.can(item.permission) == true)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.to,
                    class: "col-12 col-md-3 text-center hover-settings"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "menu-img-settings",
                        src: item.image
                      }, null, 8, _hoisted_6),
                      _createElementVNode("h5", _hoisted_7, _toDisplayString(item.label), 1),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(item.description), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ])
  ]))
}